import { Edit, FormDataConsumer, ReferenceInput, required, SelectInput, SimpleForm } from "react-admin";
import { Grid } from "@mui/material";
import BackButtonToolbar from "features/BackButtonToolbar";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { CourseChoices, FromWeekToWeekChoices, WeekDaysChoices, WeekTypeChoices } from "utils/choices";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import RoomInput from "server/components/Fields/RoomInput";
import { validateFromToWeek, validateTimeStart } from "../CreateWeeklySchedule/utils/utils";
import { activityRequests } from "api/activityApi";
const EditForeignLanguagesSchedules = () => {
  return (
    <Edit
      mutationMode="pessimistic"
      title="Редактиране на разписания за чужди езици"
      actions={<BackButtonToolbar />}
      transform={data => {
        const {
          id,
          academicSessionId,
          createdByUserId,
          createdOn,
          foreignLanguageLevelNameBg,
          foreignLanguageNameBg,
          ...payload
        } = data;
        return payload;
      }}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={8}
          >
            <ProfessorInput
              source="professorEmployeeId"
              fullWidth
              filters={{ hasForeignLanguage: true }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <SelectInput
              source="course"
              label="Курс"
              choices={CourseChoices}
              optionValue="id"
              optionText="name"
              alwaysOn
              emptyText={false}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
        >
          <FormDataConsumer>
            {({ formData }) => (
              <>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <SelectInput
                    label="От седмица"
                    source="fromWeek"
                    choices={FromWeekToWeekChoices}
                    validate={[required(), () => validateFromToWeek(formData)]}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                >
                  <SelectInput
                    label="До седмица"
                    source="toWeek"
                    choices={FromWeekToWeekChoices}
                    validate={[required(), () => validateFromToWeek(formData)]}
                  />
                </Grid>
              </>
            )}
          </FormDataConsumer>
          <Grid
            item
            xs={12}
            md={3}
          >
            <SelectInput
              label="Тип седмица"
              source="weekType"
              choices={WeekTypeChoices}
              optionValue="id"
              optionText="name"
              validate={[required()]}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <SelectInput
              source="weekDay"
              label="Ден от седмицата"
              choices={WeekDaysChoices}
              optionValue="id"
              optionText="name"
              validate={[required()]}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={8}
          >
            <RoomInput
              source="roomId"
              label="Зала"
            />
          </Grid>
          <FormDataConsumer>
            {({ formData }) => (
              <>
                <Grid
                  item
                  xs={12}
                  md={2}
                >
                  <CustomTimeOnlyInput
                    source="startTime"
                    label="Започва в (час)"
                    validate={() => validateTimeStart(formData)}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={2}
                >
                  <CustomTimeOnlyInput
                    source="endTime"
                    label="Приключва в (час)"
                    validate={() => validateTimeStart(formData)}
                  />
                </Grid>
              </>
            )}
          </FormDataConsumer>
        </Grid>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={2}
          >
            <ReferenceInput
              reference={activityRequests.getActivityForeignLanguagesSelect()}
              source="foreignLanguageId"
            >
              <SelectInput
                label="Избор на чужд език"
                optionText="name"
                validate={[required()]}
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <ReferenceInput
              reference={activityRequests.getActivityForeignLanguagesLevelsSelect()}
              source="foreignLanguageLevel"
            >
              <SelectInput
                label="Ниво на чужд език"
                optionText="name"
                validate={[required()]}
              />
            </ReferenceInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default EditForeignLanguagesSchedules;
